<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Module
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.user_id"
                outlined
                label="Enter User ID"
                prepend-inner-icon="mdi-badge-account"
                :rules="[rules.required]"
                hint="Enter the User ID of the source entity"
              ></v-text-field>
              <!-- <v-autocomplete
                v-model="form.user_id"
                :items="users"
                item-text="name"
                item-value="id"
                outlined
                label="Select User"
                prepend-inner-icon="mdi-account"
                :rules="[rules.required]"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-avatar>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      item.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete> -->
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.role_name"
                :items="roleNames"
                outlined
                label="Role Name"
                prepend-inner-icon="mdi-shield-account"
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.source_type"
                :items="sourceTypes"
                outlined
                label="Source Type"
                prepend-inner-icon="mdi-source-branch"
                :rules="[rules.required]"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.source_id"
                outlined
                label="Source ID"
                prepend-inner-icon="mdi-identifier"
                :rules="[rules.required]"
                hint="Enter the ID of the source entity"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Module
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "ModuleEditPage",
    data() {
    return {
      form: {
        company_id: 1,
        user_id: null,
        role_name: "",
        source_id: "",
        source_type: "",
        is_active: true,
      },
      roleNames: [
        // "Admin",
        // "Manager",
        "BD Member",
        "Agent",
        "Host",
        "coordinator",
        "assistant",
        "viewer",
      ],
      sourceTypes: [
        "department",
        "project",
        "Admin",
        "Manager",
        "BD Member",
        "Agent",
        "Host",
      ],
      isLoading: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    //   this.isLoading = true;
    //   let form = await axios.get(`/user_positions/${this.$route.params.userPositionId}`);
    //   this.form = form.data.data;
    //   this.old_json = form.data.data;
    //   this.isLoading = false;
    // },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userPositionId;
      axios
        .get(`/user_positions/${encryptedId}`)
        .then((response) => {
          let formData = response.data.data;
          this.form.role_name = formData.role_name;
          this.form.source_type = formData.source_type;
          this.form.user_id = formData.user.unique_id;
          this.form.source_id = formData.source.unique_id != null ? formData.source.unique_id : '';
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(`/user_positions/${this.$route.params.userPositionId}`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/module/${this.form.id}`,
          from_name: "ModuleEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push("/user_positions");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
